import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { BadgeStatusComponent } from '../../../../../shared/components/alert-status/badge-status.component';
import { BadgeComponent } from '../../../../../shared/components/badge/badge.component';
import { ImageCarouselComponent } from '../../../../../shared/components/image-carousel/image-carousel.component';
import { ProductSkuViewData } from '../../admin-product-view.model';

@Component({
  selector: 'app-sku-details-card',
  standalone: true,
  imports: [CommonModule, BadgeStatusComponent, BadgeComponent, ImageCarouselComponent],
  templateUrl: './sku-details-card.component.html',
})
export class SkuDetailsCardComponent {
  @Input({ required: true }) sku!: ProductSkuViewData;
  @Input() skuSpecifications?: Map<string, string[]>;

  getSkuImages(): string[] {
    return this.sku?.images?.map(i => i.imageUrl) ?? [];
  }
}
